// extracted by mini-css-extract-plugin
module.exports = {"container":"JournalList_container_2_fQo","downloadButton":"JournalList_downloadButton_dDuR3","disabled":"JournalList_disabled_2vg1e"};